import { useLayoutEffect } from "react";
import { appScrollElement } from "./appScroll";

const useScrollToTop = (key: unknown) => {
  useLayoutEffect(() => {
    // The app's scroll container, not the window: the window does not scroll.
    appScrollElement()?.scrollTo({ top: 0, left: 0 });
  }, [key]);
};

export default useScrollToTop;
